import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { buildWaitlistOutreachHtml } from '../../convex/emailContent';
import { WAITLIST } from '../../convex/waitlistCopy';
import s from './waitlist-email-preview.module.scss';

const APP_URL = 'https://app.usefragments.com';
const SUBJECT =
  "You're on the Fragments waitlist — could I ask you something?";
const PREVIEW_TEXT =
  'Quick ask from Conan at Fragments — three ways you can help us build the right thing.';

export const Route = createFileRoute('/waitlist-outreach-preview')({
  component: WaitlistOutreachPreviewPage,
});

function WaitlistOutreachPreviewPage() {
  // Dev-only preview, gated the same way as the confirmation-email preview.
  const isPreviewEnabled =
    import.meta.env.DEV || import.meta.env.VITE_DEV_TOOLS === 'true';

  const emailHtml = React.useMemo(
    () =>
      buildWaitlistOutreachHtml({
        firstName: 'Alex',
        surveyUrl: `${APP_URL}/survey?t=preview-token`,
        calendlyUrl: WAITLIST.calendlyUrl,
      }),
    [],
  );

  if (!isPreviewEnabled) {
    return (
      <div className={s.page}>
        <div className={s.emptyState}>
          <h1 className={s.title}>Email preview unavailable</h1>
          <p className={s.copy}>
            This route is only enabled in development so the outreach template
            can be reviewed safely before any send.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={s.page}>
      <div className={s.header}>
        <p className={s.kicker}>Waitlist outreach email</p>
        <h1 className={s.title}>Existing-signups outreach preview</h1>
        <p className={s.copy}>
          The one-off email sent to existing waitlist signups who joined before
          the confirmation email carried a survey link. Three asks — survey,
          reply, call — ordered easiest to most engaged. Not wired to any
          scheduler or send action; this preview is the only output today.
        </p>
      </div>

      <div className={s.metaGrid}>
        <div className={s.metaCard}>
          <span className={s.metaLabel}>Subject</span>
          <span className={s.metaValue}>{SUBJECT}</span>
        </div>
        <div className={s.metaCard}>
          <span className={s.metaLabel}>Preview text</span>
          <span className={s.metaValue}>{PREVIEW_TEXT}</span>
        </div>
      </div>

      <div className={s.previewGrid}>
        <section className={s.previewCard}>
          <div className={s.previewHeader}>
            <span className={s.previewLabel}>Desktop canvas</span>
            <span className={s.previewSize}>600px email width</span>
          </div>
          <div className={s.previewFrame}>
            <iframe
              srcDoc={emailHtml}
              title="Waitlist outreach desktop preview"
              className={s.iframe}
            />
          </div>
        </section>

        <section className={`${s.previewCard} ${s.mobileCard}`}>
          <div className={s.previewHeader}>
            <span className={s.previewLabel}>Mobile canvas</span>
            <span className={s.previewSize}>390px viewport</span>
          </div>
          <div className={`${s.previewFrame} ${s.mobileFrame}`}>
            <iframe
              srcDoc={emailHtml}
              title="Waitlist outreach mobile preview"
              className={s.iframe}
            />
          </div>
        </section>
      </div>
    </div>
  );
}
